<template>
  <div>
    <span
      class="ds-whitespace-nowrap"
      :class="{ 'ds-line-through': hasDiscount }"
      :title="hasDiscount ? $t('Original price') : $t('Price')"
    >
      {{ formatPrice(minPrice) }}<template v-if="hasRange"> ~ {{ formatPrice(maxPrice) }}</template></span>

    <template v-if="hasDiscount">
      <span
        class="ds-whitespace-nowrap"
        :title="$t('Current discounted price')"
        data-testid="productPriceDiscountRange"
      >
        {{ formatPrice(minPriceDiscount) }}
        <template v-if="hasRange"> ~ {{ formatPrice(maxPriceDiscount) }} </template>
      </span>
    </template>
  </div>
</template>
<script lang="ts">
//@ts-nocheck
import Product from '@monolith/legacy/types/product';
import { DineroObject } from 'dinero.js';
import { ProductCollectionItem } from '@monolith/legacy/types/account/product-collections';
import { Amount } from '@core/types/amount';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ProductsTablePrice',
  props: {
    product: {
      type: Object as () => Product | ProductCollectionItem,
      required: true,
    },
  },
  computed: {
    variants() {
      return [...this.product.variants].sort((a, b) =>
        a.price.original_wholesale_price?.amount < b.price.original_wholesale_price?.amount ? -1 : 1
      );
    },
    cheapest() {
      return this.variants[0];
    },
    priciest() {
      return this.variants[this.variants.length - 1];
    },
    minPrice(): Amount {
      return this.cheapest?.price.original_wholesale_price;
    },
    maxPrice(): Amount {
      return this.priciest?.price.original_wholesale_price;
    },
    minPriceDiscount(): Amount {
      if (this.product.wholesale_price.amount < this.cheapest?.price.wholesale_price?.amount) {
        return this.product.wholesale_price;
      }
      return this.cheapest?.price.wholesale_price;
    },
    maxPriceDiscount(): Amount {
      return this.priciest?.price.wholesale_price;
    },
    hasRange() {
      return this.minPrice?.amount < this.maxPrice?.amount;
    },
    hasDiscount(): boolean {
      return !!this.product.discount_rate;
    },
  },
  methods: {
    formatPrice(price: DineroObject): string {
      return this.$root.formatPrice(price);
    },
  },
});
</script>
